import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="92"
      height="48"
      viewBox="0 0 241 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9158 128C13.5309 128 16.1465 128 18.761 128C86.2543 128 153.748 128 221.241 128C223.856 128 226.472 128 229.087 128C230.592 128 232.096 128 233.601 128C234.105 128.001 234.592 127.944 235.083 127.827C235.319 127.77 235.55 127.7 235.778 127.618C236.698 127.284 237.451 126.806 238.141 126.11C238.238 126.013 238.331 125.912 238.422 125.809C238.85 125.319 239.185 124.793 239.449 124.198C239.457 124.182 239.464 124.165 239.471 124.148C239.604 123.843 239.711 123.533 239.794 123.211C239.797 123.203 239.799 123.194 239.801 123.186C239.935 122.661 240.001 122.141 240.001 121.6C240.001 117.333 240.001 113.067 240.001 108.8C240.001 74.6669 240.001 40.5333 240.001 6.40022C240.001 2.86567 237.136 0.000549316 233.601 0.000549316C232.096 0.000549316 230.592 0.000549316 229.087 0.000549316C227.872 0.000549316 226.656 0.000549316 225.441 0.000549316C225.407 0.000549316 225.374 0.000549316 225.339 0.000549316C225.29 0.000549316 225.24 0.000549316 225.19 0.000549316C223.874 0.000549316 222.557 0.000549316 221.24 0.000549316C153.748 0.000549316 86.2543 0.000549316 18.7604 0.000549316C17.4441 0.000549316 16.1273 0.000549316 14.811 0.000549316C14.7614 0.000549316 14.7111 0.000549316 14.6614 0.000549316C14.6276 0.000549316 14.5937 0.000549316 14.5598 0.000549316C13.3452 0.000549316 12.1293 0.000549316 10.9147 0.000549316C9.40986 0.000549316 7.90506 0.000549316 6.40026 0.000549316C2.86571 0.000549316 3.33215e-07 2.86624 3.33215e-07 6.40022C3.33215e-07 40.5338 3.33215e-07 74.6669 3.33215e-07 108.8C3.33215e-07 113.067 3.33215e-07 117.333 3.33215e-07 121.6C-0.00112855 125.135 2.86627 127.999 6.40026 128C7.90619 128 9.411 128 10.9158 128Z"
        fill="#E3E3E3"
      />
      <path
        d="M0.0012207 108.4C0.0012207 108.533 0.0012207 108.667 0.0012207 108.8C0.0012207 113.067 0.0012207 117.333 0.0012207 121.6C0.0012207 125.134 2.86633 127.999 6.40144 127.999C7.90625 127.999 9.41108 127.999 10.9159 127.999C13.531 127.999 16.1466 127.999 18.7611 127.999C48.9216 127.999 135.081 127.999 165.241 127.999C167.857 127.999 226.472 127.999 229.087 127.999C230.592 127.999 232.096 127.999 233.601 127.999C234.105 128 234.592 127.943 235.083 127.826C235.319 127.77 235.55 127.7 235.778 127.617C236.698 127.284 237.451 126.805 238.141 126.11C238.238 126.012 238.332 125.912 238.422 125.808C238.851 125.318 239.186 124.793 239.449 124.198C239.457 124.181 239.464 124.164 239.472 124.147C239.604 123.842 239.711 123.532 239.794 123.211C239.797 123.203 239.799 123.194 239.801 123.186C239.936 122.662 240.001 122.141 240.001 121.6C240.001 117.333 240.001 113.067 240.001 108.8C240.001 108.667 240.001 108.533 240.001 108.4H0.0012207Z"
        fill="url(#paint0_linear_6150_22516)"
      />
      <path
        opacity="0.2"
        d="M19.6015 0C19.3216 0 19.0416 0 18.7616 0C17.4454 0 16.1285 0 14.8122 0C14.7625 0 14.7123 0 14.6627 0C14.6288 0 14.5949 0 14.561 0C13.3458 0 12.1306 0 10.9159 0C9.41108 0 7.90625 0 6.40144 0C2.86633 0 0.0012207 2.86569 0.0012207 6.39967C0.0012207 40.5333 0.0012207 74.6663 0.0012207 108.799C0.0012207 113.066 0.0012207 117.333 0.0012207 121.599C0.0012207 125.134 2.86633 127.999 6.40144 127.999C7.90625 127.999 9.41108 127.999 10.9159 127.999C13.531 127.999 16.1466 127.999 18.7611 127.999C19.041 127.999 19.321 127.999 19.601 127.999V0H19.6015Z"
        fill="url(#paint1_linear_6150_22516)"
      />
      <path
        opacity="0.2"
        d="M220.402 0C220.682 0 220.961 0 221.241 0C222.558 0 223.875 0 225.191 0C225.241 0 225.291 0 225.34 0C225.375 0 225.408 0 225.442 0C226.658 0 227.873 0 229.088 0C230.592 0 232.097 0 233.602 0C237.136 0 240.002 2.86569 240.002 6.39967C240.002 40.5333 240.002 74.6663 240.002 108.799C240.002 113.066 240.002 117.333 240.002 121.599C240.002 125.134 237.136 127.999 233.602 127.999C232.097 127.999 230.592 127.999 229.088 127.999C226.472 127.999 223.857 127.999 221.242 127.999C220.962 127.999 220.682 127.999 220.402 127.999V0H220.402Z"
        fill="url(#paint2_linear_6150_22516)"
      />
      <path
        d="M19.8572 19.6003C19.6766 19.6003 19.6016 19.6754 19.6016 19.8566C19.6016 49.2861 19.6016 78.715 19.6016 108.145C19.6016 108.326 19.6766 108.401 19.8572 108.401C49.2868 108.401 78.7157 108.401 108.145 108.401C108.326 108.401 108.401 108.326 108.401 108.145C108.401 78.715 108.401 49.2861 108.401 19.8566C108.401 19.6754 108.326 19.6003 108.145 19.6003C78.7157 19.6003 49.2868 19.6003 19.8572 19.6003Z"
        fill="#575756"
      />
      <path
        d="M108.002 107.744C108.002 107.926 107.927 108.001 107.745 108.001C78.5825 108.001 49.4199 108.001 20.2574 108.001C20.0768 108.001 20.0017 107.926 20.0017 107.744C20.0017 78.5819 20.0017 49.4193 20.0017 20.2562C20.0017 20.0756 20.0768 20.0005 20.2574 20.0005C49.4199 20.0005 78.5825 20.0005 107.745 20.0005C107.927 20.0005 108.002 20.0756 108.002 20.2562C108.002 49.4187 108.002 78.5813 108.002 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M98.006 97.8542C98.006 97.5138 97.8694 97.3671 97.5251 97.3671C96.526 97.3671 95.5287 97.3671 94.5296 97.3671C94.5296 97.0939 94.5296 96.8201 94.5296 96.5469C94.5296 95.952 94.2288 95.5462 93.9522 95.0845C93.0084 93.5108 92.8346 91.6899 94.7898 90.8528C96.4645 90.1354 98.3277 91.3704 98.3289 93.1908C98.3289 93.3449 98.3136 93.495 98.2815 93.6457C98.2109 93.9781 98.3221 94.143 98.6517 94.2147C98.9848 94.2869 99.1524 94.178 99.2207 93.8438C99.8094 91.0707 96.8991 88.8366 94.3405 90.0016C93.1529 90.5424 92.3582 91.7006 92.2899 93.0062C92.2543 93.6841 92.4208 94.2536 92.7177 94.8485C92.9283 95.2685 93.5701 95.9831 93.5701 96.5469C93.5701 97.2886 93.5701 98.0303 93.5701 98.7714C93.5701 99.1112 93.7112 99.2517 94.051 99.2517C94.2254 99.2517 94.3992 99.2517 94.5736 99.2517C94.5736 99.3996 94.5736 99.5475 94.5736 99.6954C94.5736 100.035 94.7136 100.176 95.0534 100.176C95.5439 100.176 96.0333 100.176 96.5238 100.176C96.8636 100.176 97.0035 100.035 97.0035 99.6954C97.0035 99.5475 97.0035 99.3996 97.0035 99.2517C97.178 99.2517 97.3518 99.2517 97.5262 99.2517C97.866 99.2517 98.0071 99.1112 98.0071 98.7714C98.006 98.4661 98.006 98.1601 98.006 97.8542Z"
        fill="#575756"
      />
      <path
        d="M131.857 19.6003C131.676 19.6003 131.601 19.6754 131.601 19.8566C131.601 49.2861 131.601 78.715 131.601 108.145C131.601 108.325 131.676 108.4 131.857 108.4C161.287 108.4 190.715 108.4 220.145 108.4C220.327 108.4 220.401 108.325 220.401 108.145C220.401 78.715 220.401 49.2861 220.401 19.8566C220.401 19.6754 220.327 19.6003 220.145 19.6003C190.716 19.6003 161.287 19.6003 131.857 19.6003Z"
        fill="#575756"
      />
      <path
        d="M219.745 20.2562V20.0005H132.258"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M219.745 20.0005C219.926 20.0005 220.001 20.0756 220.001 20.2562C220.001 49.4193 220.001 78.5819 220.001 107.744C220.001 107.925 219.926 108 219.745 108C190.582 108 161.42 108 132.257 108C132.077 108 132.001 107.925 132.001 107.744C132.001 78.5819 132.001 49.4193 132.001 20.2562C132.001 20.0756 132.077 20.0005 132.257 20.0005"
        fill="#E3E3E3"
      />
      <path
        d="M176.001 94.8801C193.056 94.8801 206.881 81.0549 206.881 64.0006C206.881 46.9462 193.056 33.121 176.001 33.121C158.947 33.121 145.122 46.9462 145.122 64.0006C145.122 81.0549 158.947 94.8801 176.001 94.8801Z"
        fill="url(#paint3_linear_6150_22516)"
      />
      <path
        d="M160.641 68.5601C163.16 68.5601 165.201 66.5185 165.201 64C165.201 61.4815 163.16 59.4399 160.641 59.4399C158.123 59.4399 156.081 61.4815 156.081 64C156.081 66.5185 158.123 68.5601 160.641 68.5601Z"
        fill="#3C3C3B"
      />
      <path
        d="M191.362 68.5601C193.88 68.5601 195.922 66.5185 195.922 64C195.922 61.4815 193.88 59.4399 191.362 59.4399C188.843 59.4399 186.802 61.4815 186.802 64C186.802 66.5185 188.843 68.5601 191.362 68.5601Z"
        fill="#3C3C3B"
      />
      <path
        d="M208.67 98.0235C208.258 98.4361 208.258 99.1061 208.67 99.5193C209.084 99.933 209.751 99.9308 210.165 99.5182C210.578 99.1061 210.579 98.4361 210.166 98.0235C209.753 97.6109 209.084 97.6109 208.67 98.0235Z"
        fill="#575756"
      />
      <path
        d="M205.655 98.2916C204.923 98.2916 204.191 98.2916 203.459 98.2916C203.33 98.2911 203.277 98.238 203.277 98.1099C203.277 96.3443 203.277 94.5793 203.277 92.8143C203.277 92.685 203.33 92.6325 203.459 92.6325C205.224 92.6325 206.989 92.6325 208.754 92.6325C208.883 92.6325 208.935 92.6856 208.936 92.8143C208.936 93.5464 208.936 94.279 208.936 95.0117C208.936 95.3515 209.076 95.492 209.416 95.492C209.755 95.492 209.896 95.3515 209.896 95.0117C209.896 94.279 209.896 93.5464 209.896 92.8143C209.895 92.1838 209.384 91.6736 208.755 91.6724C206.99 91.6724 205.225 91.6724 203.46 91.6724C202.829 91.673 202.318 92.1838 202.318 92.8143C202.318 94.5793 202.318 96.3443 202.318 98.1099C202.318 98.7398 202.829 99.2512 203.46 99.2518C204.192 99.2518 204.924 99.2518 205.656 99.2518C205.994 99.2518 206.136 99.1112 206.136 98.7714C206.136 98.4317 205.993 98.2916 205.655 98.2916Z"
        fill="#575756"
      />
      <path
        d="M179.122 41.6001V33.2875C178.09 33.182 177.05 33.1199 176.002 33.1199C174.949 33.1199 173.908 33.1735 172.882 33.2762V41.5995H179.122V41.6001Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.601 59.31C149.601 55.5311 149.601 51.7516 149.601 47.9732C147.456 51.4993 146.005 55.4921 145.419 59.7599C146.663 59.7599 147.907 59.7599 149.151 59.7599C149.469 59.7599 149.601 59.6289 149.601 59.31Z"
        fill="#D0D0D0"
      />
      <path
        d="M202.895 59.7599C204.126 59.7599 205.358 59.7599 206.589 59.7599C206.581 59.7068 206.574 59.6538 206.566 59.6002C206.558 59.5471 206.551 59.4935 206.543 59.4404C205.954 55.4927 204.723 51.9745 202.722 48.5207C202.62 48.3463 202.505 48.1798 202.402 48.0082C202.402 51.7606 202.402 55.5147 202.402 59.2671C202.402 59.6154 202.546 59.7599 202.895 59.7599Z"
        fill="#D0D0D0"
      />
      <path
        d="M172.881 86.4005V94.7238C173.908 94.8265 174.948 94.8802 176.001 94.8802C177.054 94.8802 178.095 94.826 179.121 94.7238V86.4005H172.881Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.075 68.2401C147.856 68.2401 146.637 68.2401 145.418 68.2401C146.005 72.509 147.455 76.5007 149.601 80.0274C149.601 76.2738 149.601 72.5208 149.601 68.7673C149.601 68.3942 149.447 68.2401 149.075 68.2401Z"
        fill="#D0D0D0"
      />
      <path
        d="M203.013 68.2401C202.581 68.2401 202.402 68.4196 202.402 68.8514C202.402 72.5773 202.402 76.3021 202.402 80.0274C204.547 76.5007 205.998 72.509 206.584 68.2401C205.394 68.2401 204.203 68.2401 203.013 68.2401Z"
        fill="#D0D0D0"
      />
      <path
        d="M174.104 94.8096C174.734 94.8508 175.366 94.8801 176.001 94.8801C176.639 94.8801 177.27 94.8542 177.898 94.8158V85.2716H174.104V94.8096H174.104Z"
        fill="url(#paint4_linear_6150_22516)"
      />
      <path
        d="M177.899 33.191C177.269 33.1498 176.637 33.1204 176.002 33.1204C175.364 33.1204 174.733 33.1464 174.105 33.1848V42.729H177.899V33.191H177.899Z"
        fill="url(#paint5_linear_6150_22516)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6150_22516"
          x1="120.001"
          y1="109.076"
          x2="120.001"
          y2="127.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.2624" stopColor="#E5E5E5" stopOpacity="0.5" />
          <stop offset="0.5198" stopColor="#EBEBEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6150_22516"
          x1="16.5602"
          y1="64"
          x2="0.309465"
          y2="64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6150_22516"
          x1="223.443"
          y1="64"
          x2="239.693"
          y2="64"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6150_22516"
          x1="176.001"
          y1="94.8801"
          x2="176.001"
          y2="33.1204"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6150_22516"
          x1="176.002"
          y1="94.7475"
          x2="176.002"
          y2="85.2424"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6150_22516"
          x1="176.001"
          y1="33.2527"
          x2="176.001"
          y2="42.7578"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
